<template>
    <div>
        <b-row>
            <b-col>
                <b-button variant="primary" size="sm" @click="changeCampanha">Selecionar Campanha</b-button>
            </b-col>
            <b-col class="text-right" v-if="campanha">
                <b>Campanha Selecionada: {{ getCamps(campanha) }}</b>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col class="col-md-12">
                <b-card v-if="campanha != ''" no-body>
                    <b-tabs v-model="tabIndex" card>
                        <b-tab title="Produtos" :title-link-class="linkClass(0)">
                            <b-row align-v="end">
                                <b-col cols="2">
                                    <label for="">Produto</label>
                                    <b-form-input size="sm" v-model="filter.produto" type="search"
                                        @keyup.enter="loadProdutos()" placeholder="Código ou nome do produto"
                                        title="Filtar Código"></b-form-input>
                                </b-col>
                                <b-col>
                                    <label for="">Tipo</label>
                                    <b-form-select size="sm" v-model="filter.tipo" :options="['','CATALOGO', 'ENCARTE', 'REVENDA', 'AUXILIAR']" ></b-form-select>
                                </b-col>
                                <b-col>
                                    <label for="">App</label>
                                    <b-form-select size="sm" v-model="filter.ativo" :options="['', 'SIM', 'NAO']"></b-form-select>
                                </b-col>
                                <b-col>
                                    <b-button variant="primary" size="sm" @click="loadProdutos()">
                                        Buscar
                                    </b-button>
                                    <!-- BOTÃO DE EXPORTAR  -->
                                    <downloadexcel 
                                        class="btn btn-success btn-sm mx-2"
                                        :fetch="fetchDataForExport"
                                        :before-generate="exportExcel"
                                        :before-finish="finishExcel"
                                        :name="filename"
                                        :worksheet="ExportProducts"
                                        title="Lista de Produtos">
                                        <i class="far fa-file-excel"></i> Exportar
                                    </downloadexcel>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-table class="mt-2" :fields="colunas" hover :items="dataComputed" stacked="md"
                                    show-empty small empty-text="Nenhum produto encontrado!">
                                    <template #cell(id)="row">
                                        <b-button variant="primary" @click="show(row.value)"><i
                                                class="fas fa-eye"></i></b-button>
                                    </template>
                                </b-table>
                            </b-row>
                            <b-row>
                                <b-col class="col-md-8">
                                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                                        @input="loadProdutos()" align="fill" size="sm" class="my-0"></b-pagination>
                                </b-col>
                                <b-col class="text-right">
                                    Total de Itens: <b>{{ totalRows }}</b>
                                </b-col>
                                <b-col class="col-md-1">
                                    <b-form-select size="sm" v-model="perPage" :options="optionsPerPage"
                                        @change="loadProdutos()"></b-form-select>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Categorias" :title-link-class="linkClass(1)">
                            <b-row>
                                <b-table class="mt-2" :fields="colunasCategoria" hover :items="categorias"
                                    :current-page="currentPage" :per-page="perPage" :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc" :sort-direction="sortDirection" stacked="md" show-empty
                                    empty-text="Nenhuma categoria encontrada!" small>
                                    <template #cell(imagem)="row">
                                        <b-avatar v-if="row.value" :src="row.value"></b-avatar>
                                    </template>
                                    <template #cell(subcategorias)="row">
                                        <div style="font-size: 14px;">
                                            {{ row.value }}
                                        </div>
                                    </template>
                                    <template #cell(action)="row">
                                        <b-button variant="primary" @click="showCategoria(row.item)">
                                            <i class="fas fa-eye"></i>
                                        </b-button>
                                    </template>
                                </b-table>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>

        <!-- Modal Produto -->
        <b-modal v-model="modalProdutos" id="modal-produtos" size="lg" tabindex="-1"
            :title="`${produto.codigo} - ${produto.nome}`">
            <b-container>
                <b-row>
                    <b-col>
                        <div class="form-group">
                            <label>Deseja Bloquear produto no Aplicativo ?</label>
                            <select v-model="produto.showapp" class="form-control">
                                <option :value="true">Não</option>
                                <option :value="false">Sim</option>
                            </select>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-10">
                        <div class="form-group">
                            <label>Imagens:</label>
                            <b-form-file v-model="imagens" accept=".jpg, .png, .jpeg" multiple
                                placeholder="Nenhum Arquivo Selecionado" browse-text="Selecionar Arquivo" id="imagem"
                                @change="setImagemProduto"></b-form-file>
                            <!--  <b-form-file v-model="imagem" title="Imagem" placeholder="Nenhuma Imagem Selecionada" browse-text="Selecionar Arquivo" id="imagem" @change="setImagemProduto" /> -->
                        </div>
                    </b-col>
                </b-row>
                <b-row v-for="(imagem, index) in produto.imagens " :key="index" class="mt-3">
                    <b-col>
                        <a href="#" @click="showImagem(imagem)" class="show-imagem">
                            <b-img :src="imagem.path" v-bind="{ width: 80, height: 80 }" thumbnail rounded
                                fluid></b-img>
                            <span class="ml-3">
                                {{ nomeImagem(imagem.path) }}
                            </span>
                        </a>
                        <a href="#" @click="removeImagem(imagem)" class="ml-2" title="Remover">
                            <i class="fas fa-times"></i>
                        </a>
                    </b-col>
                </b-row>
            </b-container>
            <template #modal-footer>
                <b-button variant="primary" class="float-right mr-2" size="sm" @click="saveProduto">Salvar</b-button>
                <b-button variant="danger" class="float-right mr-2" size="sm"
                    @click="modalProdutos = false">Cancelar</b-button>
            </template>
        </b-modal>

        <b-modal v-model=verProduto size="xl" fluid hide-header ok-only>
            <b-container fluid>
                <b-row class="mb-1 text-center">
                    <b-img :src="pathImagem" fluid-grow />
                </b-row>
            </b-container>
        </b-modal>


        <!--- MODAL SELECIONE A CAMPANHA ATIVA. --->
        <b-modal v-model="modalCampanhas" id="modal-campanhas" tabindex="-1" title="Selecione uma Campanha" ok-only>
            <b-container>
                <b-form-select v-model="campanha" :options="camps" @change="setCampanha(campanha)"></b-form-select>
            </b-container>
            <template #modal-footer>
                <b-button variant="primary" size="sm" class="float-right"
                    @click="modalCampanhas = false">Fechar</b-button>
            </template>
        </b-modal>

        <!-- Modal da Categoria -->
        <b-modal size="lg" v-model="modalCategoria" id="modal-categoria" :title="categoriaSelecionada.categoria">
            <b-row>
                <b-col class="text-left col-md-2">
                    <label for="">Prioridade</label>
                    <b-select :options="optionsOrdem" v-model="categoriaSelecionada.ordem" />
                </b-col>
            </b-row>
            <b-row class="mb-3 mt-3" v-if="categoriaSelecionada.imagem" align-v="center">
                <b-col class="text-right">
                    <b-avatar :src="categoriaSelecionada.imagem" size="8rem"></b-avatar>
                </b-col>
                <b-col class="text-left">
                    <b-button size="sm" variant="danger" @click="removeImagemCategoria()">Remover Imagem</b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col class="col-md-12">
                    <b-form-group :label="categoriaSelecionada.imagem ? 'Alterar Ícone' : 'Adicionar Icone'"
                        label-cols-sm="2">
                        <b-form-file v-model="categoriaSelecionada.novaImagem" accept=".jpg, .png, .jpeg"
                            placeholder="Nenhum Arquivo Selecionado" browse-text="Selecionar Arquivo"
                            id="imagem"></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <template #modal-footer>
                <b-button size="sm" variant="success" @click="saveCategoria()"><i class="fas fa-save"></i>
                    Salvar</b-button>
                <b-button size="sm" variant="danger" @click="modalCategoria = false">Cancelar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import downloadexcel from "vue-json-excel";
export default {
    name: "AdmProdutos",
       components: {
        downloadexcel
    },
    data() {
        return {
            filename: "lista_produtos.xls",
            ExportProducts: "Produtos",
            isExporting: false,
            camps: [],
            categoriaSelecionada: {
                nome: '',
                id: '',
                categoria: '',
                imagem: null,
                novaImagem: null,
                ordem: '',
            },
            modalCategoria: false,
            verProduto: false,
            filter: {
                produto: "",
                tipo: "",
                ativo: ""
            },
            totalRows: 0,
            currentPage: 1,
            perPage: '20',
            sortBy: 'codigo',
            sortDesc: false,
            sortDirection: 'desc',
            modalProdutos: false,
            modalCampanhas: false,
            optionsPerPage: ['5', '10', '20', '50', '100', '1000'],
            colunasCategoria: [
                {
                    key: "action",
                    label: "Ver",
                    class: 'text-center'
                },
                {
                    key: "categoria",
                    label: "Categoria",
                    sortable: true,
                    class: 'text-center'
                },
                {
                    key: "subcategorias",
                    label: "Subcategorias",
                    sortable: true,
                    class: 'text-center'
                },
                {
                    key: "ordem",
                    label: "Prioridade",
                    sortable: true,
                    class: 'text-center'
                },
                {
                    key: "imagem",
                    label: "Ícone",
                }
            ],
            colunas: [
                {
                    key: "id",
                    label: "Ver",
                    class: 'text-center'
                },
                {
                    key: "codigo",
                    label: "Código",
                    sortDirection: 'desc',
                    class: 'text-center'
                },
                {
                    key: "nome",
                    label: "Produto",
                    class: 'text-center'
                },
                {
                    key: "descontos.tipo_produto",
                    label: "Tipo",
                    class: 'text-center',
                    formatter: (value, index, item) => {
                        if (item.descontos.tipo_desconto == 'CLASSE' &&  (item.descontos.tipo_produto == 'MR' || item.descontos.tipo_produto == 'PA')) return 'CATÁLOGO'
                        else if (item.descontos.tipo_produto == 'ENCARTE') return 'ENCARTE'
                        else if (item.descontos.tipo_desconto == 'FIXO' && item.descontos.tipo_produto == 'MR') return  'REVENDA'
                        else if (item.descontos.tipo_desconto == 'SEM_DESCONTO' && item.descontos.tipo_produto == 'MR') return 'MATERIAL AUX'
                        else { return 'TIPO INVALIDO' }
                    }
                },
                {
                    key: "pivot.pagina",
                    label: "Página",
                    class: 'text-center'
                },
                {
                    key: "pivot.preco",
                    label: "Preço R$",
                    class: 'text-center'
                },
                {
                    key: "pivot.disponivel",
                    label: "Disponível",
                    class: 'text-center',
                    formatter: (value) => {
                        return value ? 'SIM' : 'NÃO'
                    }
                },
                {
                    key: "pivot.disponivel_cd",
                    label: "Disponível CD",
                    class: 'text-center',
                    formatter: (value) => {
                        return value ? 'SIM' : 'NÃO'
                    }
                },
                {
                    key: "showapp",
                    label: "APP",
                    class: 'text-center',
                    formatter: (value) => {
                        return value ? 'SIM' : 'NÃO'
                    }
                },
                {
                    key: "imagens",
                    label: "Imagens",
                    class: 'text-center',
                    sortable: true,
                    formatter: (value) => {
                        return value ? value.length : 0
                    },
                },
            ],
            actionsTable: ["show"],
            tableData: [],
            showapp: true,
            campanhas: [],
            campanha: "",
            imagem: null,
            fields: [{
                filterByFormatted: true
            }],

            produto: {
                id: null,
                showapp: true,
                imagem: "",
                imagens: [],
                descricao: "",
                codigo: ""
            },
            imagens: [],
            imagensRemovidas: [],
            pathImagem: '',
            tabIndex: 0,
            categorias: [],
            optionsOrdem: [],
            produtos: []
        };
    },
    computed: {
        dataComputed() {
            const vm = this;
            return vm.produtos;

        },
    },

    mounted() {
        this.loadCampanhas();
        this.changeCampanha();
        this.showOrdem();
        this.loadCategorias();
    },

    methods: {

        async fetchDataForExport() {
            const vm = this;
            vm.isExporting = true;
            
            try {
                const params = {
                    campanha: vm.campanha,
                    currentPage: 1,
                    perPage: 1000000, 
                    filter: vm.filter
                };
                
                const response = await axios.get("/adm/produtos/list", { params: params });
                const produtos = response.data.data;
                
                return produtos.map(produto => ({
                    'Código': produto.codigo || '',
                    'Produto': produto.nome || '',
                    'Tipo': this.getTipoProduto(produto),
                    'Página': produto.pivot?.pagina || '',
                    'Preço R$': produto.pivot?.preco ? `R$ ${parseFloat(produto.pivot.preco).toFixed(2)}` : '',
                    'Disponível': produto.pivot?.disponivel ? 'SIM' : 'NÃO',
                    'Disponível CD': produto.pivot?.disponivel_cd ? 'SIM' : 'NÃO',
                    'APP': produto.showapp ? 'SIM' : 'NÃO',
                    'Quantidade de Imagens': produto.imagens ? produto.imagens.length : 0
                }));
            } catch (error) {
                console.error('Erro ao exportar produtos:', error);
                alert("Falha ao exportar os produtos");
                return [];
            } finally {
                vm.isExporting = false;
            }
        },
        getTipoProduto(produto) {
            if (produto.descontos?.tipo_desconto == 'CLASSE' &&  
                (produto.descontos?.tipo_produto == 'MR' || produto.descontos?.tipo_produto == 'PA')) {
                return 'CATÁLOGO';
            } else if (produto.descontos?.tipo_produto == 'ENCARTE') {
                return 'ENCARTE';
            } else if (produto.descontos?.tipo_desconto == 'FIXO' && produto.descontos?.tipo_produto == 'MR') {
                return 'REVENDA';
            } else if (produto.descontos?.tipo_desconto == 'SEM_DESCONTO' && produto.descontos?.tipo_produto == 'MR') {
                return 'MATERIAL AUX';
            } else {
                return 'TIPO INVALIDO';
            }
        },
        exportExcel() {
            this.$swal({
                title: 'Exportando...',
                text: 'Preparando arquivo Excel com todos os produtos.',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    this.$swal.showLoading();
                }
            });
        },
        finishExcel() {
            this.$swal({
                title: 'Sucesso!',
                text: 'Arquivo Excel exportado com sucesso!',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false
            });
        },
        getCamps(id) {
            const campanha = this.camps.find(el => id == el.value);
            if(campanha) {
                return campanha.text;
            } else {
                return 'campanha inválida';
            }
        },
        removeImagemCategoria() {
            this.categoriaSelecionada.imagem = '';
            this.categoriaSelecionada.removerImagem = true;
        },
        showOrdem() {
            let data = [{
                value: '',
                text: ''
            }]
            for (let i = 1; i <= 20; i++) {
                data.push({
                    value: i,
                    text: i.toString()
                })
            }
            this.optionsOrdem = data;
        },
        saveCategoria() {
            const vm = this;
            var data = new FormData();
            if (vm.categoriaSelecionada.novaImagem) {
                const img = [vm.categoriaSelecionada.novaImagem]
                data = this.getAnexosFormData(img);
                if (vm.categoriaSelecionada.novaImagem && !this.validaArquivos(img)) {
                    return
                }
            }

            data.append("categoria", vm.categoriaSelecionada.categoria);
            if (vm.categoriaSelecionada.ordem) {
                data.append("ordem", vm.categoriaSelecionada.ordem);
            }
            if (vm.categoriaSelecionada.removerImagem) {
                data.append("removerImagem", true);
            }
            axios.post("/adm/categorias", data).then((response) => {
                if (response) {
                    vm.categorias = [];
                    vm.loadCategorias();
                    vm.modalCategoria = false;
                    vm.categoriaSelecionada = {
                        nome: '',
                        id: '',
                        categoria: '',
                        imagem: null,
                        novaImagem: null,
                    }
                }
            }).catch((error) => {
                console.log(error)
                alert("Falha ao salvar categoria");
                $(".loading").hide();
            });
        },
        showCategoria(categoria) {
            this.categoriaSelecionada = categoria
            this.modalCategoria = true
        },
        linkClass(idx) {
            if (this.tabIndex === idx) {
                return ['bg-primary', 'text-light']
            } else {
                return ['bg-light', 'text-primary']
            }
        },

        showImagem(imagem) {
            this.pathImagem = imagem.path;
            this.verProduto = true
        },
        nomeImagem(path) {
            let partesDaUrl = path.split('/');
            return partesDaUrl.pop();
        },
        removeImagem(imagem) {
            let anexos = [];
            anexos = this.produto.imagens.filter(el => el.path !== imagem.path);
            this.produto.imagens = anexos;
            if (imagem.id) {
                this.imagensRemovidas.push(imagem.id);
            }
        },
        setImagemProduto(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.readImage(files[0]);
        },
        readImage(file) {
            var reader = new FileReader();
            var vm = this;

            reader.onload = e => {
                vm.produto.imagem = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        clearProduto() {
            this.produto = {
                id: null,
                showapp: true,
                descricao: "",
                imagem: "",
                codigo: "",
                imagens: []
            };
            this.imagem = null;
            this.imagens = [];
            this.imagensRemovidas = [],
                $("#imagem").val("");
        },
        changeCampanha() {
            const vm = this;
            vm.modalCampanhas = true;
        },
        async setCampanha(key) {
            const vm = this;
            await vm.loadProdutos();
            vm.modalCampanhas = false;
        },

        show(id) {
            const vm = this;
            axios
                .get("/adm/produtos", {
                    params: {
                        id: id
                    }
                })
                .then((response) => {
                    const obj = response.data;
                    vm.produto = obj;
                    vm.imagem = null;
                    vm.imagens = [];
                    vm.modalProdutos = true;
                })
                .catch((error) => {
                    alert("Falha ao carregar os produtos");
                    $(".loading").hide();
                });
        },
        getAnexosFormData(anexos) {
            let form = new FormData();
            for (let anexo of anexos) {
                if ((!anexo.id || anexo.id == 0) && anexo.idTipoAnexo) {
                    form.append(anexo.idTipoAnexo + "_new_files[]", anexo);
                } else if (!anexo.id || anexo.id == 0) {
                    form.append("new_files[]", anexo);
                } else {
                    form.append("anexo[]", anexo.id);
                    form.append('file_' + anexo.id, anexo.file);
                    form.append('file_url_' + anexo.id, anexo.url_arquivo);
                }
            }
            return form;
        },
        validaArquivos(imagens) {
            var erro = true;
            imagens.forEach((file) => {
                if (file != undefined) {
                    const maxSize = 507900; // Tamanho máximo em bytes (500kb aproximadamente)
                    const minSize = 50000;
                    const isIMG = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
                    if (file.size > maxSize) {
                        this.$swal(
                            "Atenção",
                            "O arquivo " + file.name + " é muito grande. O tamanho máximo é 500Kb.",
                            "error"
                        );
                        erro = false;
                        return;
                    } else if (file.size < minSize) {
                        /* this.$swal(
                             "Atenção",
                             "O arquivo " + file.name + " é muito pequeno. O tamanho mínimo é 50Kb.",
                             "error"
                         );
                         erro = false;
                         return false;*/
                    } else if (!isIMG) {
                        this.$swal(
                            "Atenção",
                            "Apenas arquivos JPG e PNG são permitidos.",
                            "error"
                        );
                        erro = false;
                        return false;
                    }
                }
            })
            return erro;
        },
        async saveProduto() {
            const vm = this;
            if (!this.produto.id) {
                return this.$swal(
                    "Ops",
                    "Houve um erro ao selecionar o produto, tente atualizar a página antes de prosseguir.",
                    "error"
                );
            }

            if (this.imagens.length > 0) {
                if (!this.validaArquivos(this.imagens)) {
                    return
                }
                var data = this.getAnexosFormData(this.imagens);
            } else {
                var data = new FormData;
            }

            data.append("id", vm.produto.id);
            data.append("showApp", vm.produto.showapp);
            data.append("produtosRemovidos", vm.imagensRemovidas);

            if (!this.imagem) {
                this.produto.imagem = ""
            }

            axios.post("/adm/produtos", data).then((response) => {
                vm.clearProduto();
                vm.loadProdutos();
                vm.modalProdutos = false;
            });
        },
        loadCategorias() {
            const vm = this;
            vm.categorias = [];
            axios.get("/adm/categorias")
                .then((response) => {
                    vm.categorias = response.data
                }).catch((error) => {
                    alert("Falha ao carregar as categorias");
                    $(".loading").hide();
                });
        },
        async loadProdutos() {
            var vm = this;
            $(".loading").show();
            const params = {
                campanha: vm.campanha,
                currentPage: vm.currentPage,
                perPage: vm.perPage,
                filter: vm.filter
            }
            await axios.get("/adm/produtos/list", { params: params })
                .then((response) => {
                    vm.produtos = response.data.data;
                    vm.totalRows = response.data.total;
                    if (vm.campanha === "") {
                        vm.modalCampanhas = true;
                        $(".loading").hide();
                    }
                    $(".loading").hide();
                }).catch((error) => {
                    alert("Falha ao carregar os produtos");
                    $(".loading").hide();
                });
        },

        loadCampanhas() {
            const vm = this;
            axios.get('/adm/campanhas/list')
                .then((response) => {
                    vm.camps = response.data.map((el) => {
                        return {
                            value: el.id,
                            text: el.codigo
                        }
                    })
                }).catch((error) => {
                    console.log(error)
                    alert("Falha ao carregar os campanhas");
                    $(".loading").hide();
                });
        }
    }
};
</script>

<style scoped>
.button-remove {
    position: absolute;
    top: -15px;
    right: 35px;
}

.show-imagem {
    font-size: 11px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/produtos/AdmProdutos.vue